export class LanguageVi {

    vocabulary: {};

 constructor() {

    const vocabulary = {

      botonIniciarSesion: 'Inicie sesión',
      botonCerrarSesion: 'Cerrar sesión',
      selectIdiomaEs: 'Español',
      selectIdiomaEn: 'English',
      menuPrincipalInicio: 'Inicio',
      menuPrincipalMaestros: 'Maestros',
      menuPrincipalPresupuestos: 'Presupuestos',
      menuPrincipalObras: 'Obras',
      menuPrincipalClientes: 'Clientes',
      menuPrincipalInformes: 'Informes',
      menuPrincipalImpresion: 'Impresion',
      eliminarProceso:  'Eliminar Proceso',
      refProject: 'Referencia Vino'
    };

    this.vocabulary = vocabulary;

  } // End function constructor

} // End class LanguageVi